import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import authContext from '../context/auth/authContext';

export const PublicRoutes = ({ children }) => {
    const AuthContext = useContext(authContext);
    const { autenticado } = AuthContext;

    return autenticado
        ? <Navigate to="/home" />
        : children
}